import Alpine from 'alpinejs';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './nav-overflow.js';

window.Alpine = Alpine;
Alpine.start();

function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(() => {});
